import { useEffect, useState } from "react";
import { fetchUserProfile } from "../services/newUserService";
import { normalizeProfileResult } from "../utils/profileUtils";
import { isSuperAdminRole } from "../utils/articleApprovalWorkflow";

export const useUserProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadProfile = async () => {
      try {
        const response = await fetchUserProfile();
        const normalized = normalizeProfileResult(response.data?.result);
        if (!cancelled) {
          setProfile(normalized);
        }
      } catch {
        if (!cancelled) {
          setProfile(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadProfile();

    return () => {
      cancelled = true;
    };
  }, []);

  const roleName = profile?.roleName || "";

  return {
    profile,
    loading,
    roleName,
    isSuperAdmin: isSuperAdminRole(roleName),
  };
};
